import React, { useState } from 'react'
import { Tooltip } from '@mui/material'

interface ControlsTooltipWrapperProps {
  title: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
  arrow?: boolean
  disabled?: boolean
  children: React.ReactElement
}

const ControlsTooltipWrapper: React.FC<ControlsTooltipWrapperProps> = ({ 
  title, 
  placement = 'left', 
  arrow = true,
  disabled = false,
  children 
}) => {
  const [open, setOpen] = useState(false)

  const handleClick = (event: React.MouseEvent) => {
    setOpen(false)
    if (children.props.onClick) {
      children.props.onClick(event)
    }
  }

  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow={arrow}
      open={disabled ? false : open}
      onOpen={() => !disabled && setOpen(true)}
      onClose={() => setOpen(false)}
      enterDelay={50}
      leaveDelay={0}
      disableFocusListener
      disableTouchListener
      PopperProps={{
        style: { 
          pointerEvents: 'none'
        }
      }}
    >
      <span style={{ display: 'inline-block' }}>
        {React.cloneElement(children, {
          onClick: handleClick,
        })}
      </span>
    </Tooltip>
  )
}

export default ControlsTooltipWrapper